import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable`}
            onClick={() => filter.remove()}
        >
            <svg width="14px" height="14px" fill="gray" color="gray" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
                <path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
            </svg>
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="ns-d-flex ns-flex-wrap ns-d-md-none ns-align-items-center ns-pl-2 ns-pr-2 ns-pt-2 ns-pb-2">
                <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-selected-filters">
                    {filters.map(filter => (
                        <div
                            key={`${filter.value}`}
                            class="ns-selected-filter ns-d-flex ns-align-items-center"
                        >
                            <span class="ns-selected-value"> {filter.value} </span>
                            <FilterRemoveButton filter={filter} />
                        </div>
                    ))}
                </div>
                <span
                    class="ns-anchor ns-clear-all"
                    onClick={() => {
                        removeAll()
                    }}
                >
                    Clear All
                </span>
            </div>
        )
    )
}
